module.exports = __webpack_public_path__ + "img/UEW.4b91498a.jpg";